import React from 'react'
import moment from 'moment'
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

const ConfirmationModal = ({open,ExiprationDate,handleCloseModal,handleGoAhead}) => {
  console.log("ExiprationDate ",ExiprationDate)
  return (
    <Modal show={open} onHide={handleCloseModal} >
      <Modal.Body>
        <p>Are you sure you want to proceed?</p>
        {
          moment(ExiprationDate).diff(moment(), 'days') > 0
          ?
            <p>{`You still have an active license with ${moment(ExiprationDate).diff(moment(), 'days')} days remaining`}</p>
          :
            <p>{`Your license has Already expired on ${moment(ExiprationDate).format('YYYY-MM-DD')}`}</p>
        }
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleGoAhead}>
          Yes
        </Button>
        <Button variant="secondary" onClick={handleCloseModal}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
